<app-page [inTutorial]="true">
  <trade-creator-modal [inTutorial]="true" [tutorialBuy]="true"></trade-creator-modal>
</app-page>
